import {
  appsWorkordersApiGetProductionReportGlobal,
  appsWorkordersApiListProductionReportsGlobal,
  getAppsWorkordersApiGetProductionReportGlobalQueryKey,
  getAppsWorkordersApiListProductionReportsGlobalQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsWorkordersApiListProductionReportsGlobalParams } from '@/lib/api/generated/types.ts/appsWorkordersApiListProductionReportsGlobalParams'
import type { ProductionReportOut } from '@/lib/api/generated/types.ts/productionReportOut'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

/**
 * Cross-WO ProductionReport list — drives the global «Звіти працівників»
 * sidebar entry (ADR-0003 Iter 2 frontend).
 *
 * Backend: `GET /api/production-reports?project_id=&work_order_id=&status=&created_by_id=`.
 */
export const productionReportsGlobalListQuery = (
  params?: AppsWorkordersApiListProductionReportsGlobalParams,
) =>
  typedSuspenseOptions<readonly ProductionReportOut[]>({
    queryKey: getAppsWorkordersApiListProductionReportsGlobalQueryKey(params),
    queryFn: ({ signal }) =>
      appsWorkordersApiListProductionReportsGlobal(params, { signal }) as unknown as Promise<
        readonly ProductionReportOut[]
      >,
    staleTime: 15_000,
  })

/**
 * Single ProductionReport getter for the standalone editor. Backend reads
 * project + WO from the PR record itself (WO is non-null FK).
 */
export const productionReportDetailQuery = (productionReportId: number) =>
  typedSuspenseOptions<ProductionReportOut>({
    queryKey: getAppsWorkordersApiGetProductionReportGlobalQueryKey(productionReportId),
    queryFn: ({ signal }) =>
      appsWorkordersApiGetProductionReportGlobal(productionReportId, {
        signal,
      }) as unknown as Promise<ProductionReportOut>,
    staleTime: 15_000,
  })
